import { useState, useEffect } from 'react'
import api from 'utils/api'

export default () => {
  const [kids, setKids] = useState([])
  const [error, setError] = useState(false)
  const [fetching, setFetching] = useState(false)

  useEffect(() => {
    setFetching(true)

    api
      .get('kids')
      .then(({ data }) => setKids(data.kids))
      .then(() => setFetching(false))
      .catch(() => {
        setError(true)
        setFetching(false)
      })
  }, [])

  return {
    data: kids,
    error,
    fetching,
  }
}
